/* eslint-disable */
// import EventBus from '../../libs/EventBus'

import axios from 'axios'

class AssetsPreload {

    constructor() {
        this.assets = []

        this.total = this.assets.length
        this.loaded = 0
        this.percent = 0
        this.onloaded = null
    }

    getBlob (url) {
        const asset = this.assets.find(el => el.src == url)

        if (!asset) return url

        return asset.blob || url
    }

    setAssets (assets) {
        for (const asset of assets) {
            if (!this.assets.find(el => el.src == asset)) {
                this.assets.push({
                    src: asset,
                    loaded: false,
                    load_time: 0,
                    error: false,
                    entity: null,
                    blob: null,
                    start_time: 0,
                    end_time: 0,
                    loading: false,
                })
            }
        }

        return this
    }

    run () {
        this._preload()
        return this
    }

    getProgress() {

        if (this.total == 0) {
            return {
                total: this.total,
                loaded: this.loaded,
                percent: 100
            }
        } else {
            return {
                total: this.total,
                loaded: this.loaded,
                percent: this.percent
            }
        }
        
    }

    hasError() {
        // console.log(this.assets.find(el => el.error == true) ? true : false)
        return this.assets.find(el => el.error == true) ? true : false
    }

    _loadProgress () {

        this.loaded = this.assets.filter(el => el.loaded == true).length
        this.total = this.assets.length

        if (this.total == 0) {
            this.percent = 100
        } else {
            this.percent = (this.loaded / this.total * 100).toFixed(2)
        }
        

        window.EventBus.$emit('preload_change', {
            total: this.total,
            loaded: this.loaded,
            percent: this.percent
        })

        if (this.percent == 100 && typeof this.onloaded == 'function') {
            // this.onloaded()
        }

        // console.log(this.assets.filter(el => el.loaded == true).length, '/', this.assets.length)
    }


    _preloadBlob (asset) {
        return new Promise(async (resolve, reject) => {

            asset.loading = true
            asset.start_time = new Date().getTime()
            asset.end_time = 0
            asset.process = []
            asset.total = 0
            asset.loaded = 0
            
            axios.get(asset.src, {
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {

                    const bytes = progressEvent.loaded - asset.loaded 
                    asset.total = parseFloat(progressEvent.total)
                    asset.loaded = progressEvent.loaded


                    asset.end_time = (new Date()).getTime();
                    let duration = (asset.end_time - asset.start_time) / 1000;
                    let bitsLoaded = bytes * 8;
                    let speedBps = (bitsLoaded / duration).toFixed(2);
                    let speedKbps = (speedBps / 1024).toFixed(2);
                    let speedMbps = (speedKbps / 1024).toFixed(2);

                    if (!asset.bw_low) { asset.bw_low = speedKbps}
                    if (!asset.bw_high) { asset.bw_high = speedKbps}

                    if (asset.bw_low > speedKbps ) { asset.bw_low = speedKbps }
                    if (asset.bw_high < speedKbps ) { asset.bw_high = speedKbps }

                    asset.process.push({
                        speed: speedKbps,
                        time: new Date().getTime()
                    })

                    // console.log(asset)
                },
            })
            // .then(r => r.blob())
            .then(blob => {

                // const blob = await res.blob();
                const urlBlob = URL.createObjectURL(blob.data)
                asset.blob = urlBlob
                resolve(urlBlob)

            })
            .catch (error => {

                asset.error = true
                asset.message = error?.message || ''
                asset.status = error?.status || ''
                window.window.EventBus.$emit('preload_error', this.hasError())
                window.window.EventBus.$emit('preload_error_report', asset)
                console.log(error)
                reject(error)
            })
            .finally (() => {
                asset.loading = false
                asset.loaded = true
                asset.end_time = new Date().getTime()
                asset.load_time = asset.end_time - asset.start_time

                window.window.EventBus.$emit('preload_done_report', asset)

                this._loadProgress()

            }) 
        
        
        })
    }

    _preload () {

        if (this.assets.length == 0) {
            window.EventBus.$emit('preload_change', {
                total: 0,
                loaded: true,
                percent: 100
            })
        }

        for (const asset of this.assets) {

            if (!asset.loading && !asset.blob) {
                this._preloadBlob(asset)
            }

            // let assetsPreload = null
            
            // if is image
            // if (new RegExp(['.png', '.jpg', '.jpeg', 'googleusercontent.com'].join('|')).test(asset.src)) {
                

                // this._preloadBlob(asset)
                // .then((blob) => {
                //     this._assetLoaded(asset, blob)
                // })
                // .catch((error) => {
                //     console.log(error)
                // })

                // assetsPreload = new Image();
                // assetsPreload.src = asset.src;
                // assetsPreload.onload = (event) => {
                //     this._assetLoaded(asset, event)
                // }
            // }

            // // if is audio
            // if (new RegExp(['.mp3'].join('|')).test(asset.src)) {
            //     assetsPreload = new Audio();
            //     assetsPreload.src = asset.src;
            //     assetsPreload.oncanplaythrough = (event) => {
            //         this._assetLoaded(asset, event)
            //     }
            // }

            // // if is video
            // if (new RegExp(['.mp4'].join('|')).test(asset.src)) {
            //     assetsPreload = new Audio();
            //     assetsPreload.src = asset.src;
            //     assetsPreload.oncanplaythrough = (event) => {
            //         this._assetLoaded(asset, event)
            //     }
            // }

            // if (assetsPreload) {
            //     assetsPreload.onerror = (event) => {
            //         this._assetError(asset, event)
            //     }
            //     asset.entity = assetsPreload
            // }

        }
    }

}


export default AssetsPreload